import apiClient from "./axios";

export const getFeatures = async (params = {}) => {
  const { data } = await apiClient.get("/features", { params });
  return data;
};

export const getFeature = async (id) => {
  const { data } = await apiClient.get(`/features/${id}`);
  return data;
};

export const createFeature = async (featureData) => {
  const { data } = await apiClient.post("/features", featureData);
  return data;
};

export const editFeature = async ({ id, ...featureData }) => {
  const { data } = await apiClient.patch(`/features/${id}`, featureData);
  return data;
};

export const deleteFeature = async (id) => {
  const { data } = await apiClient.delete(`/features/${id}`);
  return data;
};
